import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment-timezone';
import { modals } from '@/mixins/modal';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';
import ConfirmRestore from './confirm-restore';

export default Vue.component('admin-backups', {
  template: require('./template.html'),
  name: 'admin-backups',
  mixins: [modals, guid],
  computed: {
    ...mapGetters(['currentUser']),
    checks() {
      return {
        passedStarter: moment(this.chosenDate).isBefore(this.threshold.starter),
        passedPremium: moment(this.chosenDate).isBefore(this.threshold.premium),
      };
    },
  },
  components: {
    Datepicker,
    ConfirmRestore,
    tooltip,
    dropsLoader,
  },
  data() {
    const today = moment().utc()._d;
    const premium = moment().utc().subtract(30, 'days')._d;
    const starter = moment().utc().subtract(7, 'days')._d;
    return {
      chosenDate: today,
      fetched: false,
      threshold: {
        starter,
        premium,
      },
      chosenDateFormat: today,
      highlightDate: {
        dates: [today],
      },
      dateFormat: 'MMM dd, yyyy',
      disabledDates: { to: premium, from: today },
      loaders: {
        getBackups: false,
      },
      activeBackup: {},
      modals: {
        confirmRestore: false,
      },
      siteList: [],
    };
  },
  mounted() {
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    closeDatePicker() {
      const picker = this.$refs.setPicker;
      if (!_.isUndefined(picker.clickOutside)) {
        picker.clickOutside(event);
      }
    },
    setDate() {
      this.siteList = [];
      this.fetched = false;
    },
    async getBackups() {
      this.loaders.getBackups = true;
      const date = moment(this.chosenDate).format('YYYY-MM-DD');
      try {
        this.siteList = [];
        const { websites } = await this.$lightning([{
          name: 'getBackups',
          payload: { date },
        }]);
        this.siteList = websites;
        this.fetched = true;
      } catch (e) {
        const message = e.message || e;
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'error',
          message,
        });
        this.$log.error(message);
        await this._reportError({
          error: e,
          fn: 'getBackups',
        });
      } finally {
        this.loaders.getBackups = false;
        this._trackEvent({
          type: 'get_backups',
          meta: { date },
        });
      }
    },
    restoreWebsite(site) {
      this.activeBackup = site;
      this.toggleModal('confirmRestore', 'child');
    },
    getHint(site) {
      let hint = '';
      if (site.tier === 'Free' || (site.tier === 'Starter' && this.checks.passedStarter)) {
        hint = '(No Backup Available)';
      }
      return hint;
    },
    toggleModal(type, c) {
      this.modals[type] = !this.modals[type];
      const content = !c ? this.$refs[type] : this.$refs[type].$el;
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/backups/index.js